export enum DocumentUploadState {
  // File accepted and queued but not yet being uploaded.
  WAITING = 1,
  // Byte transfer in progress.
  UPLOADING = 2,
  // All upload steps completed successfully (presign + upload + complete).
  DONE = 3,
  // Upload failed at any step; error details live beside file progress state.
  ERROR = 4,
}
